import { render } from "./CRMLocalitiesView.vue?vue&type=template&id=d4f193d4"
import script from "./CRMLocalitiesView.vue?vue&type=script&lang=js"
export * from "./CRMLocalitiesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__